export const CHUNK_RELOAD_KEY = "chunk-reload";

export function isChunkLoadMessage(message: string): boolean {
  const normalizedMessage = message.toLowerCase();
  return (
    normalizedMessage.includes("failed to fetch dynamically imported module") ||
    normalizedMessage.includes("unable to preload css for ") ||
    normalizedMessage.includes("importing a module script failed") ||
    normalizedMessage.includes("is not a valid javascript mime type") ||
    (normalizedMessage.includes("module script") && normalizedMessage.includes("mime type")) ||
    (normalizedMessage.includes("loading chunk") && normalizedMessage.includes("failed")) ||
    (normalizedMessage.includes("loading css chunk") && normalizedMessage.includes("failed"))
  );
}

export function getErrorMessage(error: unknown): string {
  if (typeof error === "string") {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "";
}

export function isChunkLoadError(error: unknown): boolean {
  return isChunkLoadMessage(getErrorMessage(error));
}
